import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group d-flex flex-wrap" }
const _hoisted_16 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group d-flex flex-wrap" }
const _hoisted_19 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group d-flex flex-wrap" }
const _hoisted_23 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group d-flex flex-wrap" }
const _hoisted_26 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group d-flex flex-wrap" }
const _hoisted_30 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group d-flex flex-wrap" }
const _hoisted_33 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group d-flex flex-wrap" }
const _hoisted_37 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "form-group d-flex flex-wrap" }
const _hoisted_40 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "form-group d-flex flex-wrap" }
const _hoisted_44 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-7" }, null, -1)
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "form-group d-flex flex-wrap" }
const _hoisted_49 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "form-group d-flex flex-wrap" }
const _hoisted_52 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_53 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_55 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_56 = { class: "indicator-label" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_58 = { class: "indicator-progress" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_60 = { class: "card mb-5 mb-xl-10" }
const _hoisted_61 = { class: "card-header border-0" }
const _hoisted_62 = { class: "card-title m-0" }
const _hoisted_63 = { class: "fw-boldest m-0" }
const _hoisted_64 = { class: "card-body border-top p-9" }
const _hoisted_65 = { class: "mb-10" }
const _hoisted_66 = { class: "m-0 ms-n4" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "svg-icon svg-icon-3" }
const _hoisted_69 = { class: "card mb-5 mb-xl-10" }
const _hoisted_70 = { class: "card-header border-0" }
const _hoisted_71 = { class: "card-title m-0" }
const _hoisted_72 = { class: "fw-boldest m-0" }
const _hoisted_73 = { class: "card-body border-top p-9" }
const _hoisted_74 = { class: "mb-10" }
const _hoisted_75 = ["innerHTML"]
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { class: "svg-icon svg-icon-3" }
const _hoisted_78 = { class: "card mb-5 mb-xl-10" }
const _hoisted_79 = { class: "card-header border-0" }
const _hoisted_80 = { class: "card-title m-0" }
const _hoisted_81 = { class: "fw-boldest m-0" }
const _hoisted_82 = { class: "card-body border-top p-9" }
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-md-6" }
const _hoisted_85 = { class: "form-group d-flex flex-wrap" }
const _hoisted_86 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_87 = { class: "el-form-item__content" }
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = { class: "form-group d-flex flex-wrap" }
const _hoisted_90 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_91 = { class: "el-form-item__content" }
const _hoisted_92 = { class: "col-md-6" }
const _hoisted_93 = { class: "form-group d-flex flex-wrap" }
const _hoisted_94 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_95 = { class: "el-form-item__content" }
const _hoisted_96 = { class: "col-md-6" }
const _hoisted_97 = { class: "form-group d-flex flex-wrap" }
const _hoisted_98 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_99 = { class: "el-form-item__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ShowContentModel = _resolveComponent("ShowContentModel")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      model: _ctx.formData,
      rules: _ctx.rules,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("common.information")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("callOutRecords.taskOwner")), 1),
                  _createVNode(_component_el_form_item, { prop: "task_owner" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.task_owner,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.task_owner) = $event)),
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsEnter'),
                        "remote-method": _ctx.searchTaskOwnerItems,
                        loading: _ctx.taskOwnerLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskOwnerOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("callOutRecords.subject")), 1),
                  _createVNode(_component_el_form_item, { prop: "subject" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.subject,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.subject) = $event)),
                        multiple: "",
                        clearable: "",
                        "collapse-tags": "",
                        "collapse-tags-tooltip": "",
                        placeholder: _ctx.t('common.plsSelect'),
                        loading: _ctx.subjectLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjectOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("callOutRecords.contact")), 1),
                  _createVNode(_component_el_form_item, { prop: "contact" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.contact,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.contact) = $event)),
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsEnter'),
                        "remote-method": _ctx.searchContactItems,
                        loading: _ctx.contactLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t("callOutRecords.dueDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "due_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.due_date,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.due_date) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'due_date')
                  ))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("callOutRecords.actionDate")), 1),
                  _createVNode(_component_el_form_item, { prop: "action_date" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.formData.action_date,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.action_date) = $event)),
                        type: "date",
                        clearable: "",
                        placeholder: _ctx.t('common.pickDate'),
                        style: {"width":"100%"},
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (
                    _ctx.commonChangeDefaultDate($event, _ctx.formData, 'action_date')
                  ))
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("callOutRecords.channel")), 1),
                  _createVNode(_component_el_form_item, { prop: "channel" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.formData.channel,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.channel) = $event)),
                        size: "mini"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("callOutRecords.Call")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("callOutRecords.Chat")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("callOutRecords.importance")), 1),
                  _createVNode(_component_el_form_item, { prop: "importance" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.formData.importance,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.importance) = $event)),
                        size: "mini"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("callOutRecords.important")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: 2 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("callOutRecords.conventional")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: 3 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("callOutRecords.invalid")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("callOutRecords.comment")), 1),
                  _createVNode(_component_el_form_item, { prop: "comment" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.comment,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.comment) = $event)),
                        type: "textarea",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.t("callOutRecords.commentTagging")), 1),
                  _createVNode(_component_el_form_item, { prop: "comment_tagging" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.comment_tagging,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.comment_tagging) = $event)),
                        multiple: "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        loading: _ctx.commentTaggingLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentTaggingOptions, (group, key) => {
                            return (_openBlock(), _createBlock(_component_el_option_group, {
                              key: key,
                              label: group.label
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t("callOutRecords.taskSource")), 1),
                  _createVNode(_component_el_form_item, { prop: "task_source" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.task_source,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.task_source) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: _ctx.t('influencerAccount.account'),
                            value: "1"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.t('influencerAccount.lead'),
                            value: "2"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.t('influencerAccount.salesInteraction'),
                            value: "3"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.t('influencerAccount.campaign'),
                            value: "4"
                          }, null, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.t('callOutRecords.fulfillmentException'),
                            value: "5"
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.t("callOutRecords.campaign")), 1),
                  _createVNode(_component_el_form_item, { prop: "task_source_data_id" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.task_source_data_id,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.task_source_data_id) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaignOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ], 512), [
              [_vShow, _ctx.formData.task_source == 4]
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.t("callOutRecords.collaboration")), 1),
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.t("callOutRecords.shareTo")), 1),
                  _createVNode(_component_el_form_item, { prop: "share_to" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.share_to,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.share_to) = $event)),
                        multiple: "",
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        loading: _ctx.shareToLoading,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shareToOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "loading"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.t("callOutRecords.reviewNotice")), 1),
                  _createVNode(_component_el_form_item, { prop: "review_notice" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.review_notice,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.review_notice) = $event)),
                        type: "textarea",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_router_link, {
              to: '/task-management/call-out-records/',
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _hoisted_54,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_55, [
              _createElementVNode("span", _hoisted_56, [
                _hoisted_57,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
              ]),
              _createElementVNode("span", _hoisted_58, [
                _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                _hoisted_59
              ])
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("h3", _hoisted_63, _toDisplayString(_ctx.t("accountValidation.relatedSop")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createVNode(_component_el_table, {
                data: _ctx.options.sop,
                style: {"width":"100%"},
                size: "small",
                "min-width": "220"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('standardOperatingProcedure.subject'),
                    prop: "subject",
                    width: "180"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('standardOperatingProcedure.checkList')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("div", null, [
                        _createElementVNode("ol", _hoisted_66, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.check_list, (item, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item.check_list), 1))
                          }), 128))
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table_column, {
                    label: "",
                    width: "80",
                    align: "right"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("button", {
                        type: "button",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_show_content",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                        onClick: ($event: any) => (
                    _ctx.showContentModel(
                      _ctx.t('accountValidation.standardOperatingProcedure'),
                      row.check_list
                    )
                  )
                      }, [
                        _createElementVNode("span", _hoisted_68, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                        ])
                      ], 8, _hoisted_67)
                    ]),
                    _: 1
                  })), [
                    [_directive_auth, { auth: ['update'] }]
                  ])
                ]),
                _: 1
              }, 8, ["data"])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ]),
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("h3", _hoisted_72, _toDisplayString(_ctx.t("accountValidation.standardScript")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createVNode(_component_el_table, {
                data: _ctx.options.standard_script,
                style: {"width":"100%"},
                size: "small",
                "min-width": "220"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('standardScript.subject'),
                    prop: "subject",
                    width: "180"
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('accountValidation.script')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("div", {
                        innerHTML: row.script,
                        class: "pt-4"
                      }, null, 8, _hoisted_75)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table_column, {
                    label: "",
                    width: "80",
                    align: "right"
                  }, {
                    default: _withCtx(({ row }) => [
                      _createElementVNode("button", {
                        type: "button",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_show_content",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-3",
                        onClick: ($event: any) => (
                    _ctx.showContentModel(
                      _ctx.t('accountValidation.standardScript'),
                      row.script
                    )
                  )
                      }, [
                        _createElementVNode("span", _hoisted_77, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                        ])
                      ], 8, _hoisted_76)
                    ]),
                    _: 1
                  })), [
                    [_directive_auth, { auth: ['update'] }]
                  ])
                ]),
                _: 1
              }, 8, ["data"])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("div", _hoisted_78, [
      _createElementVNode("div", _hoisted_79, [
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("h3", _hoisted_81, _toDisplayString(_ctx.t("common.historyLog")), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_82, [
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.t("common.creator")), 1),
              _createElementVNode("div", _hoisted_87, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.created_user,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.__show.created_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("label", _hoisted_90, _toDisplayString(_ctx.t("common.creationDate")), 1),
              _createElementVNode("div", _hoisted_91, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.created_at,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.created_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.t("common.lastModifiedBy")), 1),
              _createElementVNode("div", _hoisted_95, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.updated_user,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.__show.updated_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.t("common.lastModifiedDate")), 1),
              _createElementVNode("div", _hoisted_99, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.updated_at,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.updated_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode(_component_ShowContentModel, {
      title: _ctx.showTitle,
      content: _ctx.showContent
    }, null, 8, ["title", "content"])
  ], 64))
}